import React from 'react';

import styles from './LoaderElementAbsolute.module.css';

const LoaderElementAbsolute = () => {
  return (
    <div className={styles.loaderOverlay}>
      <div className={styles.loader}></div>
    </div>
  );
};

export default LoaderElementAbsolute;
